import geoSwissApi from '../utils/geoSwissApi';

export const getLocationFromZip = (zip) => geoSwissApi('', { params: { where: `plz_code = ${zip}` } });
